import { useEffect } from "react";
import { usePostPropertyFlatMutation } from "web_myplann/Api/Portfolio/Mutations/usePostPropertyFlatMutation";
import { Routing } from "web_myplann/Infrastructure/Routing/Routing";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { FlatFormFields } from "web_myplann/Portfolio/Forms/FlatForm/FlatFormFields";
import { FLAT_FORM_DEFAULT_VALUES } from "web_myplann/Portfolio/Forms/FlatForm/flatFormDefaults";
import {
	type FlatFormInput,
	getFlatFormSchema,
} from "web_myplann/Portfolio/Forms/FlatForm/flatFormSchema";
import { RealEstateTypeRow } from "web_myplann/Portfolio/Forms/RealEstateForm/RealEstateTypeRow";
import type { RealEstateType } from "web_myplann/Portfolio/Forms/RealEstateForm/realEstateTypes";
import { PortfolioFormShell } from "web_myplann/Portfolio/PortfolioShared/PortfolioFormShell";
import { useCreatePortfolioForm } from "web_myplann/Portfolio/PortfolioShared/useCreatePortfolioForm";

type CreateFlatFormProps = {
	type: RealEstateType;
	onTypeChange: (type: RealEstateType) => void;
	registerSnapshot: (getValues: () => FlatFormInput) => void;
	initialValues: FlatFormInput | undefined;
};

export const CreateFlatForm = ({
	type,
	onTypeChange,
	registerSnapshot,
	initialValues,
}: CreateFlatFormProps) => {
	const { t } = useResource();

	const { mutate, isPending } = usePostPropertyFlatMutation();

	const { form, onSubmit } = useCreatePortfolioForm({
		schema: getFlatFormSchema(t),
		defaultValues: initialValues ?? FLAT_FORM_DEFAULT_VALUES,
		mutate,
		successRoute: Routing.Portfolio.PortfolioAddRealEstateSuccess.path(),
	});

	useEffect(() => {
		registerSnapshot(form.getValues);
	}, [registerSnapshot, form.getValues]);

	return (
		<PortfolioFormShell
			onSubmit={onSubmit}
			submitLabel={t(Resources.Portfolio.AddRealEstate.submit)}
			disabled={!form.formState.isDirty}
			loading={isPending}
		>
			<RealEstateTypeRow mode="select" value={type} onChange={onTypeChange} />
			<FlatFormFields control={form.control} />
		</PortfolioFormShell>
	);
};
